export default __webpack_public_path__ + "static/media/banner_guru.d6fd63a7.svg";